import view from "../../views/social.js";
import KTAPI from "../api/index.api.js";
import { KTLang } from "../lang/lang.js";
import { _handler, _user } from "../classes/index.classes";
import { router, toggleLoader } from "../router/index.routes";
import { msgDialog, welcomeDialog } from "./offscreen.controller.js";


const removeHtmlTags = str => str.replace(/<[^>]*>|&lt;[^&gt;]*&gt;/g, '');
const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);

const bgColors = {announcement: 'light-primary', new: 'light-info', event: 'light-danger', update: 'light-success'};

var loading = false;

let cropper; // Variable para almacenar la instancia del cropper

var emojiTextArea = null;
let emojiPicker = null;

var newListSkeleton = /*html*/`<div class="card-body skeleton-loader-news">
    <div class="row">
        <!-- Image link -->
        <div class="col-12 col-sm-6 d-flex mb-6 mb-sm-0">
            <div class="skeleton-loader-news-image"></div>
        </div>
        <!-- Text content -->
        <div class="col-12 col-sm-6 d-flex flex-column justify-content-center">
            <div class="d-inline-block">
                <div class="skeleton-loader-news-badge"></div>
            </div>
            <!-- Title link -->
            <div class="skeleton-loader-news-title"></div>
            <!-- Description -->
            <div class="skeleton-loader-news-description"></div>
            <!-- Additional information -->
            <div class="d-flex gap-5 mw-100 mt-8">
                <div class="d-flex align-items-center w-100 flex-grow-1">
                    <div class="symbol symbol-35px me-3 rounded overflow-hidden skeleton-loader-news-avatar"></div>
                    <div class="d-flex justify-content-start flex-column w-100">
                        <div class="d-flex align-items-center">
                            <div class="skeleton-loader-news-author"></div>
                        </div>
                        <div class="d-flex">
                            <div class="skeleton-loader-news-timestamp"></div>
                            <span class="mx-3">·</span>
                            <div class="skeleton-loader-news-date"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

`;



const videoMatcher = [
    // Matcher personalizado para detectar enlaces de YouTube
    [Node.TEXT_NODE, (node, delta) => {
      let regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]+)/g;
      let matches;
      while ((matches = regex.exec(node.data)) !== null) {
        let start = matches.index;
        let end = start + matches[0].length;
        delta.retain(start).delete(matches[0].length);
        delta.retain(1, { video: `https://www.youtube.com/watch?v=${matches[1]}` });
        delta.retain(node.data.length - start - 1);
      }
      return delta;
    }]
  ];

function imageHandler(dataUrl, type, imageData) {
    imageData.minify({})
        .then((miniImageData) => {
            var file = miniImageData.toFile(`clipboard_img_${Date.now()}.png`);
            var fileList = new DataTransfer();
            fileList.items.add(file);
            $('#imageInput')[0].files = fileList.files;
            $('#imageInput').trigger('change');
        })
}

export const createYotubeEmbed = (params) => {

    const html = `<div class="over position-relative cursor-pointer bg-transparent w-100" videoid="${params.videoId}">
                    <img src="${params.thumbnails[4].url}" class="img-fluid w-100 h-auto" alt="${params.title}">
                    <div class="position-absolute top-50 start-50 w-80px h-80px" style="transform: translate(-50%, -50%);">
                        <div class="d-flex w-100 h-100 align-items-center justify-content-center bg-opacity-50 bg-light rounded">
                            <i class="bi bi-play-circle fs-4qx text-white"></i>
                            <span class="visually-hidden">Play video</span>
                        </div>
                    </div>
                </div>
    `;

    let $videoWrapper = $(html);
    $(`#${params.container}`).html($videoWrapper);

}

function createYoutubePreview(params) {
    const html = `  
                    <div class="d-flex flex-column align-items-center">
                        <div class="position-relative cursor-pointer bg-transparent" videoid="${params.videoId}">
                        <img src="${params.thumbnails[3].url}" class="img-fluid w-100 h-auto" alt="${params.title}">
                            <div class="position-absolute top-50 start-50 w-80px h-80px" style="transform: translate(-50%, -50%);">
                                <div class="d-flex w-100 h-100 align-items-center justify-content-center bg-opacity-50 bg-light rounded">
                                    <i class="bi bi-play-circle fs-4qx text-white"></i>
                                    <span class="visually-hidden">Play video</span>
                                </div>
                            </div>
                        </div>                        
                        <h4 class="card-title d-flex flex-column align-items-start align-self-start py-3 px-4">
                                <span class="card-label fw-bold text-white text-uppercase">${params.title}</span>
                                <span class="bg-white rounded text-muted mt-1 fw-semibold fs-8 px-2 py-1 d-flex align-items-center gap-1"><i class="fab fa-youtube fs-6 text-danger"></i> Youtube</span>
                        </h4>
                    </div>
                    <div class="position-absolute top-0 end-0 mt-5 me-5">                    
                        <span class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow" data-bs-toggle="tooltip" data-bs-dismiss="click" title="Remove" id="post-dismiss-video"><i class="bi bi-x fs-2"></i></span>                    
                    </div>
    `;

    let $videoWrapper = $(html);
    $(`#${params.container}`).html($videoWrapper);

}

const registerQuillEmoji = () => {
    const Embed = Quill.import("blots/embed");
    class EmojiBlot extends Embed {
        static create(data) {
            //console.log("EmojiBlot create", data);
            let node = super.create();
            if(data.classes == '' || data.classes == null || data.classes === undefined) data.classes = 'em';
            data.classes.split(" ").forEach(iconClass => {
                node.classList.add(iconClass);
            });
            
            node.setAttribute("id", data.id);
            node.setAttribute("native", data.native);
            node.setAttribute("unified", data.unified);
            node.setAttribute("set", data.set);
            node.setAttribute("size", data.size);

            return node;
        }

        static formats(node) {
            
            let format = {};
            if (node.hasAttribute("class")) {
                format.class = node.getAttribute("class");
            }
            
            return format;
        }

        static value(node) {                   

            let ret = {
                classes: node.getAttribute("class"),
                id: node.getAttribute("id"),
                native: node.getAttribute("native"),
                unified: node.getAttribute("unified"),
                set: node.getAttribute("set"),
                size: node.getAttribute("size"),
            };           
            return ret;
        }

        format(name, value) {
            if (name === "class") {
                if (value) {
                    this.domNode.setAttribute(name, value);
                } else {
                    this.domNode.removeAttribute(name, value);
                }
            } else {
                super.format(name, value);
            }
        }
    }

    EmojiBlot.blotName = "emoji";
    EmojiBlot.tagName = "em-emoji";
    Quill.register({
        "formats/emoji": EmojiBlot
    });

    // Define la clase CentralizedVideo
    const DefaultVideo = Quill.import('formats/video');

    class CentralizedVideo extends DefaultVideo {
        static create(value) {
            let node = super.create(value);

            // Definir ancho y alto del video
            node.width = 560;
            node.height = 315;

            // Agregar clases de alineación y centrado
            node.classList.add('ql-align-center');

            return node;
        }
    }
    CentralizedVideo.blotName = 'video';
    CentralizedVideo.className = 'ql-video';
    CentralizedVideo.tagName = 'iframe';
    Quill.register(CentralizedVideo);

};

const pickerOptions = {
    data: window.emojiData.facebook,
    set: 'facebook',
    theme: 'dark',
    previewPosition: 'none',
    onEmojiSelect: function (emoji) {
        
        const content = emojiTextArea[0];
        let thisQuill = Quill.find(content);
        thisQuill.focus();        
        let editorSelection = thisQuill.getSelection();
        const cursorPosition = editorSelection && editorSelection.index ? editorSelection.index : 0;        
        thisQuill.insertEmbed(cursorPosition, 'emoji', {classes: `em`, id: emoji.id, native: emoji.native, unified: emoji.unified, set: pickerOptions.set, size: "1.125em"});
        thisQuill.setSelection(cursorPosition + 1, 'silent');
        
    }
};
registerQuillEmoji();



let sectionMenu = null;


let support = {
    render: () => {   
        //console.log("rendering social.js view...");     
        return view;
    },
    after_render: async (data) => {    
                
        startSocial();
        KTScroll.init();
        $("#kt_content_container").localize();

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};


async function initEmojiPicker() {

    $('.emoji-btn').popover({
        html: true,
        content: "Loading...",
    });


}

async function startSocial() {
    if (_user.authed) {
        $("#feed-new-post-avatar").attr("src", _user.me.avatar);
        $(".feed-new-post").removeClass("d-none");

        if (Quill.find($('#social-post-input')[0])) Quill.find('#social-post-input').destroy();

        let editor = new Quill('#social-post-input', {
            theme: 'snow',
            modules: {
                toolbar: false,                
                imageDropAndPaste: {
                    handler: imageHandler,
                },
                clipboard:{
                    allowed:{
                        tags: ['em-emoji'],
                        attributes: ['id','native','unified','set','size']
                    },
                    substituteBlockElements: true,
                    hooks: {
                        beforeSanitizeElements(node, data, config) {
                            if(node.tagName && node.tagName.toLowerCase() === "em-emoji")
                            {
                                console.log("beforeSanitizeElements", node);                                
                                node.classList.remove("em");
                                node.innerHTML = '';

                                return node;
                            }
                        },                        
                    },
                }
            }
        });

        editor.lastYoutubeLink = null;

        // Agregar un matcher personalizado para el HTML pegado
        /*editor.clipboard.addMatcher('text/html', function(node, delta) {
            console.log("clipboard matcher");
            if(node.tagName && node.tagName.toLowerCase() === "em-emoji")
            { 
                node.classList.remove("em");
                node.innerHTML = '';
                // Devolver el delta que refleje cualquier cambio en el HTML pegado
                return new Delta().insert(node.outerHTML);
            }
            return delta;            
        })*/

        editor.on('text-change', async function (delta, oldDelta, source) {
            // Obtener contenido del editor
            let content = editor.root.innerHTML;

            // Expresión regular para encontrar enlaces de YouTube
            let youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

            // Buscar coincidencias de enlaces de YouTube
            let matches = content.match(youtubeRegex);

            // Si se encuentra un enlace de YouTube
            if (matches) {
                let currentYoutubeLink = matches[0];
                // Verificar si el enlace de YouTube actual es diferente al último insertado
                if (currentYoutubeLink !== editor.lastYoutubeLink) {
                    // Formatear el enlace para insertarlo como video centrado
                    let videoUrl = `https://www.youtube.com/embed/${matches[1]}?showinfo=0`;

                    // Insertar el video en el editor
                    //editor.clipboard.dangerouslyPasteHTML(editor.getLength(), `<iframe src="${videoUrl}" class="ql-video ql-align-center" width="560" height="315" frameborder="0" allowfullscreen="true"></iframe>`);
                    // Actualizar el último enlace de YouTube insertado
                    console.log("inserting video", videoUrl);
                    editor.lastYoutubeLink = currentYoutubeLink;

                    let videoData = await KTAPI.getYotubeVideoInfo({videoId: matches[1]});
                    if(videoData.message !== "error")
                    {
                        createYoutubePreview({container: "videoPreview", ...videoData.res.videoDetails});
                    };
                    
                }
            }
        });

        console.log("Start Social");

       
        console.log("Start Social 2");

        initEmojiPicker();
    }

    if (sectionMenu) sectionMenu.destroy();
    sectionMenu = new KTMenu($("#social-main-menu")[0]);

}

async function renderSkeleton(show)
{
    if(show)
    {
        $(".news-list").append(newListSkeleton);       
    }
    else
    {        
        $(".skeleton-loader-news").remove();        
    }
}



$(document).ready(function () {

    $(document).on("click", ".rotate[data-kt-rotate=true]", function (e) {
        this.classList.toggle('active');
    });

    $(document).on("click", "#social-image-btn", function (e) {
        $('#imageInput').trigger("click");
    });

    $(document).on("change", '#imageInput', function (e) {
        const input = e.target;
        //console.log("a", input.files);

        if (input.files && input.files[0]) {
            const reader = new FileReader();

            reader.onload = function (e) {
                
                if (cropper) {
                    cropper.destroy();
                }

                // Mostrar la imagen en un modal o contenedor específico
                $('#imagePreview').html(
                    `<img class="mw-100 mh-100" src="${e.target.result}">
                        <div class="position-absolute top-0 end-0 mt-5 me-5">
                        <!--begin::Remove button-->
                        <span class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow" data-bs-toggle="tooltip" data-bs-dismiss="click" title="Remove" id="post-dismiss-image">
                            <i class="bi bi-x fs-2"></i>
                        </span>
                        <!--end::Remove button-->
                        </div>
                `);

            };

            reader.readAsDataURL(input.files[0]);
        }
    });

    // Manejar el clic en el botón de remoción de la imagen
    $(document).on("click", "#post-dismiss-image", function (e) {
        // Destruir el cropper si existe
        if (cropper) {
            cropper.destroy();
        }

        // Limpiar la vista previa de la imagen
        $('#imagePreview').html('');

        // Limpiar el valor del input para que el mismo archivo pueda ser seleccionado nuevamente
        $('#imageInput').val('');

    });

    // Manejar el clic en el botón de remoción de la imagen
    $(document).on("click", "#post-dismiss-video", function (e) {        

        // Limpiar la vista previa de la imagen
        $('#videoPreview').html('');
        

    });

    // Muestra el popover cuando se hace clic en el botón de emoji
    $(document).on('click', '.emoji-btn', function (e) {
        $(this).popover('show');
    });

    // Cierra el popover cuando se hace clic fuera de él
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.emoji-btn').length && !$(event.target).closest('.popover').length) {
            $('.emoji-btn').popover('hide');
        }
    });

    $(document).on("show.bs.popover", ".emoji-btn", function (e) {
        //if(emojiPicker == null) {emojiPicker = new EmojiMart.Picker(pickerOptions);}
        emojiPicker = new EmojiMart.Picker(pickerOptions);
        emojiTextArea = $($(this).attr('emoji-textarea'));
        let popid = $(this).attr('aria-describedby');
        var popover = bootstrap.Popover.getInstance(e.target);
        popover._config.content = emojiPicker;
        popover.setContent();

        $(`#${popid}`).find('.popover-body').addClass('mw-auto p-0');

        let thisQuill = Quill.find(emojiTextArea[0]);
        thisQuill.focus();
    });

    $(document).on("hide.bs.popover", ".emoji-btn", function (e) {
        const content = emojiTextArea[0];
        let thisQuill = Quill.find(content);
        thisQuill.focus();
    });


    $(document).on("click", ".over", async function (e) {
        let ifram = `<div class="player embed-responsive embed-responsive-16by9">
            <iframe src="${`https://www.youtube.com/embed/${$(this).attr("videoid")}?feature=oembed&autoplay=1`}" class="embed-responsive-item" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>`;
        console.log("ifram", ifram);
        $(this).replaceWith(ifram);
                        
    });


    $(document).on("paste", function (e) {
        var target = $(e.target);
    
        // Verificar si el elemento objetivo o alguno de sus ancestros tiene la clase .ql-editor
        if (target.hasClass('ql-editor') || target.closest('.ql-editor').length > 0) {
            var pastedText = (e.originalEvent || e).clipboardData.getData('text/plain');
            var pastedHtml = (e.originalEvent || e).clipboardData.getData('text/html');
    
            console.log("pasted html on quill", pastedHtml);
    
            // Verificar si el HTML pegado contiene algún elemento <em-emoji>
            var hasEmojiElement = pastedHtml.includes("<em-emoji");
            console.log("hasEmojiElement", hasEmojiElement);
    
            // Si se encuentra algún elemento <em-emoji>, eliminar su contenido
            if (hasEmojiElement) {
                // Buscar y reemplazar el contenido de los elementos <em-emoji> con una cadena vacía
                pastedHtml = pastedHtml.replace(/<em-emoji[^>]*>[\s\S]*?<\/em-emoji>/g, '');
    
                // Actualizar el contenido del portapapeles con el HTML modificado
                e.originalEvent.clipboardData.setData('text/html', pastedHtml);
    
                console.log("pastedHtml", pastedHtml);
            }
    
            // Hacer lo que necesites con el pastedText y pastedHtml aquí
        }
    });
    



});


  

export default support;